import { render, staticRenderFns } from "./novahome.vue?vue&type=template&id=af426960&scoped=true&"
import script from "./novahome.vue?vue&type=script&lang=js&"
export * from "./novahome.vue?vue&type=script&lang=js&"
import style0 from "./novahome.vue?vue&type=style&index=0&id=af426960&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af426960",
  null
  
)

export default component.exports